import { AppBar, Button, Divider, Toolbar, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { ThemeProvider, createTheme } from '@mui/material';
import Logo from '../../assets/kore_logo.png';
import { Box } from "@mui/system";
import { useState } from "react";
import AccountMenu from "./AccountMenu";
import { Login, LogOut } from "../../config/keycloak";
import { useStore } from "../../store";
import { useKeycloak } from "@react-keycloak/web";

const theme = createTheme({
    palette: {
        primary: {
            main: "#fff",
            contrastText: '#f58320'
        },
        secondary: {
            main: "#CB6100"
        }
    }
});

const Header = () => {

    const [iconClicked, _] = useState<boolean>(false);

    const { dispatch } = useStore()
    const { keycloak } = useKeycloak()

    const logoutHandler = async () => {
        LogOut();
        dispatch({ type: 'PURGE_STATE', payload: null })
    }

    const SignInHandler = () => {
        Login();
    }

    return (
        <ThemeProvider theme={theme}>
            <AppBar position="static" sx={{ borderBottom: '1px solid #cdcdcd' }}>
                <Toolbar>

                    <Box display="flex" sx={{ flexGrow: 1 }} justifyContent={"space-between"}>
                        <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                            <img src={Logo} alt="Logo" height={40} />
                            <Divider variant="middle" orientation="vertical" sx={{ mx: 1.5, height: '80%', borderRightWidth: 'medium' }} />
                            <Typography style={{ color: '#FF8312', padding: '2px 10px', fontSize: '1.5rem', fontFamily: "Roboto", fontWeight: '400' }}>Monitoring</Typography>

                        </Link>
                        {keycloak?.authenticated ? <AccountMenu onLogout={logoutHandler} isOpenPopup={iconClicked} /> : <Button sx={{ background: "#ff8312", '&:hover': { background: "#ff8312" } }} onClick={SignInHandler}>Sign In</Button>}
                    </Box>
                </Toolbar>
            </AppBar>
        </ThemeProvider>
    )
}

export default Header;
